import { AxiosInstance } from "axios";

/**
 * Caller bug reports (GLE-8483). A report becomes one Linear issue, then one
 * Slack message with the issue link. The status route is the switch: the
 * backend says `enabled` only once it has its Linear config.
 */

export const BUG_REPORT_SEVERITIES = ["low", "medium", "high"] as const;

export type BugReportSeverityT = (typeof BUG_REPORT_SEVERITIES)[number];

export interface CreateBugReportRequestI {
  title: string;
  severity: BugReportSeverityT;
  description: string;
  loom_url?: string;
  page_url?: string;
  list_id?: string;
  campaign_id?: string;
}

export interface CreateBugReportResponseI {
  /** The Linear issue ID, e.g. "GLE-123". */
  issue_identifier: string;
  issue_url: string;
  /** False when the Slack post failed after the issue was created. */
  slack_posted: boolean;
}

export interface GetBugReportStatusResponseI {
  enabled: boolean;
}

export const BugReportsAPIEndpoints = (api: AxiosInstance) => ({
  getBugReportStatus: () =>
    api.get<GetBugReportStatusResponseI>("/v1/bug_reports/status"),

  createBugReport: (body: CreateBugReportRequestI) =>
    api.post<CreateBugReportResponseI>("/v1/bug_reports", body),
});
